/**
 * Query keys for the shared geography reference data (MYN-46). Shared
 * between the startup HQ dropdowns and the investor geography-preference
 * picker - one source, not a per-feature duplicate.
 */
export const GEOGRAPHY_KEYS = {
  countries: ['geography', 'countries'] as const,
  states: ['geography', 'states'] as const,
  cities: (stateId: number, search: string) => ['geography', 'cities', stateId, search] as const,
  citiesByCountry: (countryId: number, search: string) =>
    ['geography', 'cities', 'country', countryId, search] as const,
};
